import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { ProjectImageData } from '../../interfaces/project-image-data.interface';
import { ImageDataService } from '../../services/image-data.service';
import { ModalService } from 'src/app/shared/modal/shared/modal.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { BilderkatalogMethodInterface } from '../../interfaces/bilderkatalog-method.interface';

@Component({
  selector: 'avs-bilderkatalog',
  templateUrl: './bilderkatalog.component.html',
  styleUrls: ['./bilderkatalog.component.css']
})
export class BilderkatalogComponent {
  protected readonly environment = environment;


  @Input() public title: string = '';
  @Input() public images: ProjectImageData[] = [];
  @Input() public methods: BilderkatalogMethodInterface[] = [];

  @Input() public controlsStellcode?: number;


  @Output() myClick = new EventEmitter();
  @Output() genericMethod = new EventEmitter();
  @Input() preSelectedImage: ProjectImageData | undefined;
  constructor(private imageDataService: ImageDataService,
    private modalService: ModalService,
    private dialog: MatDialog,
  ) { }



  onImageClicked(image: ProjectImageData) {
    if (this.preSelectedImage) { this.preSelectedImage = undefined }
    else { this.preSelectedImage = image; }
    this.myClick.emit(image);
  }

  genericTitleMethod(name: string) {

    this.genericMethod.emit(name);
  }

  public getImagePath(image: ProjectImageData): string {
    if (!image.path) {
      return 'assets/icons/broken_image.svg';
    }

    if (image.path.startsWith('assets/')) {
      return image.path;
    }

    return environment.apiAddress + image.path;
  }

}
